/**
 * The `state` of one trip to Google's consent page, kept in `sessionStorage` until the return page
 * reads it — `useWebCheckout`'s precedent. Every touch is wrapped: reading the property throws
 * where site data is blocked, and then nothing can be matched, so the return is refused.
 */

const KEY = 'movebuddy.googleCalendar.state';

/** The page Google sends the browser back to — one of the backend's allowed redirects. */
export function googleReturnPage(): string {
  return `${window.location.origin}/konto/google`;
}

/** @returns whether the state was kept; a trip that cannot be matched is not started. */
export function stashGoogleState(state: string): boolean {
  try {
    window.sessionStorage.setItem(KEY, state);
    return window.sessionStorage.getItem(KEY) === state;
  } catch {
    return false;
  }
}

export function readGoogleState(): string | null {
  try {
    return window.sessionStorage.getItem(KEY);
  } catch {
    return null;
  }
}

export function forgetGoogleState(): void {
  try {
    window.sessionStorage.removeItem(KEY);
  } catch {
    /* Nothing to forget where nothing could be kept. */
  }
}
